import PropTypes from 'prop-types';
import { useState } from 'react';

export default function Search(props) {
	const classes = ['glossary__search'];
	const [searchTerm, setSearchTerm] = useState('');

	const handleSearch = (event) => {
		const term = event.target.value;
		setSearchTerm(term);
		props.onSearch(term);
	};

	const handleClear = () => {
		setSearchTerm('');
		props.onSearch('');
	};

	return (
		<div className={classes.join(' ')}>
			<div className="form-field">
				<label htmlFor="searchInput">{props.labels.input_label}</label>
				<div className="glossary__search--input-container">
					<input placeholder={props.labels.default_placeholder} type="text" id="searchInput" value={searchTerm} onChange={handleSearch} />
					{searchTerm && <span className="clear-icon" onClick={handleClear}></span>}
				</div>
			</div>
		</div>
	);
}

Search.propTypes = {
	onSearch: PropTypes.func,
	onClick: PropTypes.func,
	labels: PropTypes.object,
};
